import { useState, useEffect, useCallback } from 'react';

export const usePWA = () => {
    const [isPWA, setIsPWA] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const checkPWA = () => {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            const isIOSStandalone = (window.navigator as any).standalone === true;
            setIsPWA(isStandalone || isIOSStandalone);
        };

        checkPWA();

        // Check if iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
        if (isIOS && !((window.navigator as any).standalone)) {
            setIsInstallable(true);
        }

        const handleBeforeInstallPrompt = (e: any) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Update UI notify the user they can install the PWA
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        const handleAppInstalled = () => {
            setIsInstallable(false);
            setDeferredPrompt(null);

        };

        window.addEventListener('appinstalled', handleAppInstalled);

        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        const onChange = (e: MediaQueryListEvent) => setIsPWA(e.matches || (window.navigator as any).standalone === true);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', onChange);
        } else {
            mediaQuery.addListener(onChange);
        }

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', onChange);
            } else {
                mediaQuery.removeListener(onChange);
            }
        };
    }, []);

    const installPWA = useCallback(async () => {
        if (!deferredPrompt) {
            return;
        }
        // Show the install prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        await deferredPrompt.userChoice;

        // We've used the prompt, and can't use it again, throw it away
        setDeferredPrompt(null);
        setIsInstallable(false);
    }, [deferredPrompt]);

    return { isPWA, isInstallable, installPWA };
};
